import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { SrOperationResourceItem } from '@app/services/sr-operation.service';

@Injectable({ providedIn: 'root' })
export class SrReportService {
    constructor(private readonly datatask: DataTaskService) {}
    /** @datatask 1313 */
    public async getFindReport(): Promise<SrFindReportGet> { return (await this.datatask.Post(1313, {}))[0]; }
    /** @datatask 1314 */
    public findReports(params: { searchtext: string }): Promise<Item[]> { return this.datatask.Post(1314, params); }
    /** @datatask 1315 */
    public async getMenu(params: SrReportMenuParams): Promise<SrReportMenuGet> { return (await this.datatask.Post(1315, params))[0]; }
    /** @datatask 1630 */
    public getMenuItems(params: SrReportMenuParams): Promise<Item[]> { return this.datatask.Post(1630, params); }
    /** @datatask 2144 */
    public getResponsibleLabours(params: { resource_id: string }): Promise<Item[]> { return this.datatask.Post(2144, params); }
    /** @datatask 2145 */
    public async setResponsibleLabour(params: SrReportMenuParams & { responsible_labour_no: string }): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2145, params))[0]; }
    /** @datatask 2108 */
    public async changeStatus(params: SrReportMenuParams): Promise<ErrorMessageResponse> { return (await this.datatask.Post(2108, params))[0]; }
    /** @datatask 1478 */
    public async getIncompleteReports(params: { resource_id: string }): Promise<SrNotCompletedGet> { return (await this.datatask.Post(1478, params))[0]; }
    /** @datatask 992 */
    public getIncompleteReportList(params: { resource_id: string }): Promise<Item[]> { return this.datatask.Post(992, params); }
    /** @datatask 1479 */
    public async getNewIncompleteReport(params: { resource_id: string }): Promise<SrNotCompletedNewGet> { return (await this.datatask.Post(1479, params))[0]; }
    /** @datatask 1481 */
    public getIncompleteReportResources(): Promise<SrOperationResourceItem[]> { return this.datatask.Post(1481, {}); }
    /** @datatask 1480 */
    public getIncompleteReportEvents(): Promise<SrReportEvent[]> { return this.datatask.Post(1480, {}); }
    /** @datatask 1482 */
    public async saveIncompleteReport(page: SrNotCompletedNewGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1482, page))[0]; }
}

export interface SrNotCompletedGet {
    resource_id: string;
    show_button_new_report: string;
    text_button_new_report: string;
}
export interface SrNotCompletedNewGet {
    resource_id: string;
    first_alert: string;
    special_event_id?: string | null;
    special_where: string;
    special_object: string;
}
export interface SrReportEvent { event_id: string; event_name: string; }

export interface SrReportMenuParams { checklistdata_keyno: string; }
export interface SrFindReportGet { searchtext?: string | null; }
export interface SrReportMenuGet extends SrReportMenuParams {
    bg_srreportmenu_main: string;
    page_heading: string;
    custact_no: string;
    special_hrsno: string;
    srstatusinfo: string;
    special_status_id: string;
    report_checklist_name: string;
    resource_id: string;
    responsible_labour_no: string;
    special_event_name: string;
    special_where: string;
    special_object: string;
    show_button_fill_in_report: string;
    show_button_change_report: string;
    show_button_changestatus: string;
    refund_access: string;
    travelbill_no: string;
}
